import { withStyles } from "@mui/styles";
import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import HeaderMenu from "src/components/header-menu";
import Api from "src/services/api";
import { Styles } from "src/styles/material-styles";
import clsx from 'clsx';
import { Alert, Box, Button, CircularProgress, ClickAwayListener, Container, CssBaseline, FormControlLabel, Grid, IconButton, InputAdornment, Pagination, Paper, Switch, Tab, Tabs, TextField, Tooltip, Typography } from "@mui/material";
import { Overlay } from "src/styles/global";
import CustomizedSnackbars from "src/components/material-snackbars";
import { AbilityContext } from "src/config/ability-context";
import PropTypes from 'prop-types';
import * as componentActions from '../../redux/actions/groups';
import { Info, Search, Settings } from "@mui/icons-material";
import { Tab as RTab, Tabs as RTabs, TabList as RTabList, TabPanel as RTabPanel } from 'react-tabs'
import { PapiroConsole } from "src/utils/papiroConsole";
import CalledCard from "./components/calleds-card";
import UserCard from "./components/user-card";
import ArticleCard from "./components/article-card";
import FaqCard from "./components/faq-card";
import KnowledgeBaseCard from "./components/knowledgebase-card";
import moment from "moment";
import SimpleDatePicker from 'src/components/date-pickers/inline-no-today'
import calleds from "src/redux/reducers/calleds";


class GeneralSearch extends Component {
    constructor(props) {
        super(props)

        const searchPreferences = JSON.parse(localStorage.getItem("generalSearchPreferences"))
        const { userSession, intl } = props
        
        let usematerializedview = false

        if (userSession && userSession.user && userSession.user.usematerializedview) {
            usematerializedview = userSession.user.usematerializedview
        }

        this.isClient = true;
        this.isAdm = false;
        this.isTechnical = false
        this.admGlobal = false;
        this.isAdmOrg = false;
        this.isCoordenator = false;
        this.usematerializedview = usematerializedview
        if (userSession == null || userSession.user == null || userSession.user.userrole == null) {
            Api.logoff()
        }
        this.userOrganizations = userSession.user.userorganizations;

        userSession.user.userrole.map((item, key) => {
            if (item.role.roletype != 3) {
                this.isClient = false
            }
            if (item.role.roletype == 2) {
                this.isTechnical = true
            }
            if (item.role.roletype == 0 || item.role.roletype == 1 || item.role.roletype == 4) {
                this.isAdm = true;
            }
            if (item.role.roletype == 1)
                this.isAdmOrg = true
            if (item.role.roletype == 4)
                this.isCoordenator = true
            if (item.role.roletype == 0) {
                this.admGlobal = true
            }
        })


        this.state = {
            searchResults: [],
            searchResultsCount: 0,
            page: 1,
            totalPages: 0,
            pageStart: 0,
            pageEnd: 0,

            calledsCount: 0,
            usersCount: 0,
            newsCount: 0,
            faqsCount: 0,
            knowledgebasesCount: 0,
            activeTab: 0,
            settingsOpen: false,

            alertMessage: '',
            alertType: intl.formatMessage({ id: "general.search.max.period" }),

            searchPreferences: searchPreferences !== null ? searchPreferences : {
                searchText: '',
                selectedTab: 0,
                general: {
                    startdate: moment().subtract(6, 'months').format('YYYY/MM/DD HH:mm:ss'),
                    enddate: moment().format('YYYY/MM/DD HH:mm:ss'),
                },
                calleds: {
                    id: true,
                    title: true,
                    description: false,
                    accompaniments: false,
                    users: false,
                    attatchments: false,
                    quicksearch: this.usematerializedview,
                },
                users: {
                    name: true,
                    email: true,
                    document: true,
                    phone: true,
                },
                news: {
                    title: true,
                    subtitle: true,
                    content: true,
                    articlesectionname: true,
                    attatchments: true,
                    user: true
                },
                faq: {
                    question: true,
                    answer: true,
                    subjectname: true,
                },
                knowledgebases: {
                    title: true,
                    description: true,
                    keywords: true,
                    attatchments: true,
                }
            },

            loading: false,
            openNotification: false,
            notificationVariant: 'error',
            notificationMessage: '',

            settingsTabs: [
                {
                    name: "general",
                    label: intl.formatMessage({ id: "general" }),
                    switches: [
                        { name: "startdate", label: intl.formatMessage({ id: "start.date" }) },
                        { name: "enddate", label: intl.formatMessage({ id: "end.date" }) },
                    ]
                },
                {
                    name: "calleds",
                    label: intl.formatMessage({ id: "called.header" }),
                    switches: [
                        { name: "id", label: intl.formatMessage({ id: "id" }) },
                        { name: "title", label: intl.formatMessage({ id: "title" }) },
                        { name: "description", label: intl.formatMessage({ id: "description" }) },
                        { name: "accompaniments", label: intl.formatMessage({ id: "accompaniments" }) },
                        { name: "users", label: intl.formatMessage({ id: "menu.users" }) },
                        { name: "attatchments", label: intl.formatMessage({ id: "attachments" }) },
                        { name: "quicksearch", label: intl.formatMessage({ id: "quick.search" }) },
                    ],
                },
                {
                    name: "users",
                    label: intl.formatMessage({ id: "menu.users" }),
                    switches: [
                        { name: "name", label: intl.formatMessage({ id: "name" }) },
                        { name: "email", label: intl.formatMessage({ id: "email" }) },
                        { name: "phone", label: intl.formatMessage({ id: "phone" }) },
                        { name: "document", label: intl.formatMessage({ id: "document" }) }
                    ],
                },
                {
                    name: "news",
                    label: intl.formatMessage({ id: "news" }),
                    switches: [
                        { name: "title", label: intl.formatMessage({ id: "title" }) },
                        { name: "subtitle", label: intl.formatMessage({ id: "subtitle" }) },
                        { name: "content", label: intl.formatMessage({ id: "content" }) },
                        { name: "articlesectionname", label: intl.formatMessage({ id: "section.name" }) },
                        { name: "user", label: intl.formatMessage({ id: "user" }) },
                        { name: "attatchments", label: intl.formatMessage({ id: "attachments" }) }
                    ]
                },
                {
                    name: "faq",
                    label: intl.formatMessage({ id: "faq" }),
                    switches: [
                        { name: "question", label: intl.formatMessage({ id: "question" }) },
                        { name: "answer", label: intl.formatMessage({ id: "response" }) },
                        { name: "subjectname", label: intl.formatMessage({ id: "subject" }) },
                    ]
                },
                {
                    name: "knowledgebases",
                    label: intl.formatMessage({ id: "knowledgebases" }),
                    switches: [
                        { name: "title", label: intl.formatMessage({ id: "title" }) },
                        { name: "description", label: intl.formatMessage({ id: "description" }) },
                        { name: "keywords", label: intl.formatMessage({ id: "keywords" }) },
                        { name: "attatchments", label: intl.formatMessage({ id: "attachments" }) }
                    ]
                }
            ]
        }

        this.containerRef = React.createRef()

        this.handleClickAway = this.handleClickAway.bind(this)
        this.handleChangeSearchText = this.handleChangeSearchText.bind(this)
        this.setSelectedTab = this.setSelectedTab.bind(this)
        this.handleTabChange = this.handleTabChange.bind(this)
        this.handleSwitchChange = this.handleSwitchChange.bind(this)
        this.closeNotification = this.closeNotification.bind(this)
        this.handleKeyDown = this.handleKeyDown.bind(this)
        this.handleSearch = this.handleSearch.bind(this)
        this.onChangePaginate = this.onChangePaginate.bind(this)
        this.setNotification = this.setNotification.bind(this)
        this.setLoading = this.setLoading.bind(this)
    }

    async componentDidMount() {
        //document.addEventListener("mousedown", this.handleClickAway)

        await this.handleSearch(this.state.searchPreferences.selectedTab)
    }

    handleClickAway = (event) => {
        if (
            this.containerRef.current &&
            !this.containerRef.current.contains(event.target)
        ) {
            this.setState({
                settingsOpen: false,
            })
        }
    }

    validateDateRange = () => {
        const { startdate, enddate } = this.state.searchPreferences.general
        const { intl } = this.props
        const startDateMoment = moment(startdate, 'YYYY/MM/DD HH:mm:ss')
        const endDateMoment = moment(enddate, 'YYYY/MM/DD HH:mm:ss')
        const maxDateRange = startDateMoment.clone().add(6, 'months')

        var message = intl.formatMessage({ id: "general.search.max.period" })
        if (startDateMoment.isAfter(endDateMoment)) {
            message = intl.formatMessage({ id: "report.audit.initial.date.higher.than.end.date" })
            this.setState({ alertType: "error", alertMessage: message })
            return { valid: false, message: message }
        }
        if (endDateMoment.isAfter(maxDateRange)) {
            this.setState({ alertType: "error", alertMessage: message })
            return { valid: false, message: message }
        }
        if (startDateMoment.isAfter(moment())) {
            message = intl.formatMessage({ id: "called.time.entries.registration.date.field" })
            this.setState({ alertType: "error", alertMessage: message })
            return { valid: false, message: message }
        }
        this.setState({ alertType: "info", alertMessage: message })
        return { valid: true, message: message }
    }

    resetCount = () => {
        this.setState({ searchResults: [], searchResultsCount: 0, pageStart: 0, pageEnd: 0, page: 1, calledsCount: 0, newsCount: 0, usersCount: 0, faqsCount: 0, knowledgebasesCount: 0, totalPages: 0 })
    }

    async getCalleds() {
        const { intl } = this.props

        if (this.state.searchPreferences.searchText <= 0) {
            this.setNotification("error", intl.formatMessage({ id: "value.to.search" }))
            this.resetCount()
            return
        }

        const tab = this.state.searchPreferences.selectedTab
        let searchById = false

        let formdata = new FormData()

        for (let key in this.state.searchPreferences.general) {
            if (this.state.searchPreferences.general[key] !== null && this.state.searchPreferences.general[key] !== undefined) {
                formdata.append(key, this.state.searchPreferences.general[key])
            }
        }
        for (let key in this.state.searchPreferences.calleds) {
            if (this.state.searchPreferences.calleds[key] !== null && this.state.searchPreferences.calleds[key] !== undefined) {
                formdata.append(key, this.state.searchPreferences.calleds[key])
                if (key === "id") {
                    searchById = true
                }
            }
        }


        let url = `calleds/general-search?searchText=${this.state.searchPreferences.searchText}&page=${this.state.page}`

        if (tab !== 0) {
            url += `&onlycount=true`
        }

        let config = {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }

        await Api.post(url, formdata, config)
            .then((result) => {
                if (result.data.success) {
                    if (tab == 0 && searchById && result.data.count == 1 && Number.isInteger(Number(this.state.searchPreferences.searchText))) {
                        // Redirect to called details
                        this.setState({ loading: false })
                        const calledId = result.data.data[0].id
                        const l = this.props.match.params.lang
                        this.props.history.push(`/${l}/called-accompaniment/${calledId}`)
                    }
                    if (tab === 0) {
                        this.setState({
                            calledsCount: result.data.count,
                            searchResults: result.data.data,
                            searchResultsCount: result.data.count
                        })
                        this.setPagination(result.data.count, this.state.page)
                    } else {
                        this.setState({
                            calledsCount: result.data.count
                        })
                    }
                } else {
                    this.setState({
                        openNotification: true,
                        notificationVariant: 'error',
                        notificationMessage: result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    })
                }
            })
            .catch((err) => {
                this.setState({
                    openNotification: true,
                    notificationVariant: 'error',
                    notificationMessage: err.errors ? err.errors[0] : intl.formatMessage({ id: "process.error" })
                })
            })
    }

    async getNews() {
        const { intl } = this.props

        if (this.state.searchPreferences.searchText <= 0) {
            this.setNotification("error", intl.formatMessage({ id: "value.to.search" }))
            this.resetCount()
            return
        }

        const tab = this.state.searchPreferences.selectedTab

        let formdata = new FormData()

        for (let key in this.state.searchPreferences.general) {
            if (this.state.searchPreferences.general[key] !== null && this.state.searchPreferences.general[key] !== undefined) {
                formdata.append(key, this.state.searchPreferences.general[key])
            }
        }
        for (let key in this.state.searchPreferences.news) {
            if (this.state.searchPreferences.news[key] !== null && this.state.searchPreferences.news[key] !== undefined) {
                formdata.append(key, this.state.searchPreferences.news[key])
            }
        }

        let url = `articles/general-search?searchText=${this.state.searchPreferences.searchText}&page=${this.state.page}`

        if (tab !== 1) {
            url += `&onlycount=true`
        }
        let config = {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }

        await Api.post(url, formdata, config)
            .then((result) => {
                if (result.data.success) {
                    if (tab === 1) {
                        this.setState({
                            newsCount: result.data.count,
                            searchResults: result.data.data,
                            searchResultsCount: result.data.count
                        })
                        this.setPagination(result.data.count, this.state.page)
                    } else {
                        this.setState({
                            newsCount: result.data.count
                        })
                    }
                } else {
                    this.setState({
                        openNotification: true,
                        notificationVariant: 'error',
                        notificationMessage: result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    })
                }
            })
            .catch((err) => {
                this.setState({
                    openNotification: true,
                    notificationVariant: 'error',
                    notificationMessage: err.errors ? err.errors[0] : intl.formatMessage({ id: "process.error" })
                })
            })
    }

    async getFaqs() {
        const { intl } = this.props

        if (this.state.searchPreferences.searchText <= 0) {
            this.setNotification("error", intl.formatMessage({ id: "value.to.search" }))
            this.resetCount()
            return
        }

        const tab = this.state.searchPreferences.selectedTab

        let formdata = new FormData()

        for (let key in this.state.searchPreferences.general) {
            if (this.state.searchPreferences.general[key] !== null && this.state.searchPreferences.general[key] !== undefined) {
                formdata.append(key, this.state.searchPreferences.general[key])
            }
        }
        for (let key in this.state.searchPreferences.faq) {
            if (this.state.searchPreferences.faq[key] !== null && this.state.searchPreferences.faq[key] !== undefined) {
                formdata.append(key, this.state.searchPreferences.faq[key])
            }
        }

        let url = `faq/general-search?searchText=${this.state.searchPreferences.searchText}&page=${this.state.page}`

        if (tab !== 2) {
            url += `&onlycount=true`
        }
        let config = {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }

        await Api.post(url, formdata, config)
            .then((result) => {
                if (result.data.success) {
                    if (tab === 2) {
                        this.setState({
                            faqsCount: result.data.count,
                            searchResults: result.data.data,
                            searchResultsCount: result.data.count
                        })
                        this.setPagination(result.data.count, this.state.page)
                    } else {
                        this.setState({
                            faqsCount: result.data.count
                        })
                    }
                } else {
                    this.setState({
                        openNotification: true,
                        notificationVariant: 'error',
                        notificationMessage: result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    })
                }
            })
            .catch((err) => {
                this.setState({
                    openNotification: true,
                    notificationVariant: 'error',
                    notificationMessage: err.errors ? err.errors[0] : intl.formatMessage({ id: "process.error" })
                })
            })
    }

    async getKnowledgebases() {
        const { intl } = this.props

        if (this.state.searchPreferences.searchText <= 0) {
            this.setNotification("error", intl.formatMessage({ id: "value.to.search" }))
            this.resetCount()
            return
        }

        const tab = this.state.searchPreferences.selectedTab

        let formdata = new FormData()

        for (let key in this.state.searchPreferences.general) {
            if (this.state.searchPreferences.general[key] !== null && this.state.searchPreferences.general[key] !== undefined) {
                formdata.append(key, this.state.searchPreferences.general[key])
            }
        }
        for (let key in this.state.searchPreferences.knowledgebases) {
            if (this.state.searchPreferences.knowledgebases[key] !== null && this.state.searchPreferences.knowledgebases[key] !== undefined) {
                formdata.append(key, this.state.searchPreferences.knowledgebases[key])
            }
        }

        let url = `knowledgebases/general-search?searchText=${this.state.searchPreferences.searchText}&page=${this.state.page}`

        if (tab !== 3) {
            url += `&onlycount=true`
        }
        let config = {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }

        await Api.post(url, formdata, config)
            .then((result) => {
                if (result.data.success) {
                    if (tab === 3) {
                        this.setState({
                            knowledgebasesCount: result.data.count,
                            searchResults: result.data.data,
                            searchResultsCount: result.data.count
                        })
                        this.setPagination(result.data.count, this.state.page)
                    } else {
                        this.setState({
                            knowledgebasesCount: result.data.count
                        })
                    }
                } else {
                    this.setState({
                        openNotification: true,
                        notificationVariant: 'error',
                        notificationMessage: result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    })
                }
            })
            .catch((err) => {
                this.setState({
                    openNotification: true,
                    notificationVariant: 'error',
                    notificationMessage: err.errors ? err.errors[0] : intl.formatMessage({ id: "process.error" })
                })
            })
    }

    async getUsers() {
        if (this.isAdm) {
            const { intl } = this.props

            if (this.state.searchPreferences.searchText <= 0) {
                this.setNotification("error", intl.formatMessage({ id: "value.to.search" }))
                this.resetCount()
                return
            }


            const tab = this.state.searchPreferences.selectedTab

            let formdata = new FormData()

            for (let key in this.state.searchPreferences.general) {
                if (this.state.searchPreferences.general[key] !== null && this.state.searchPreferences.general[key] !== undefined) {
                    formdata.append(key, this.state.searchPreferences.general[key])
                }
            }
            for (let key in this.state.searchPreferences.users) {
                if (this.state.searchPreferences.users[key] !== null && this.state.searchPreferences.users[key] !== undefined) {
                    formdata.append(key, this.state.searchPreferences.users[key])
                }
            }

            let url = `users/general-search?searchText=${this.state.searchPreferences.searchText}&page=${this.state.page}`

            if (tab !== 4) {
                url += `&onlycount=true`
            }

            let config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }

            await Api.post(url, formdata, config)
                .then((result) => {
                    if (result.data.success) {
                        if (tab === 4) {
                            this.setState({
                                usersCount: result.data.count,
                                searchResults: result.data.data,
                                searchResultsCount: result.data.count
                            })
                            this.setPagination(result.data.count, this.state.page)
                        } else {
                            this.setState({
                                usersCount: result.data.count
                            })
                        }
                    } else {
                        this.setState({
                            openNotification: true,
                            notificationVariant: 'error',
                            notificationMessage: result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
                        })
                    }
                })
                .catch((err) => {
                    this.setState({
                        openNotification: true,
                        notificationVariant: 'error',
                        notificationMessage: err.errors ? err.errors[0] : intl.formatMessage({ id: "process.error" })
                    })
                })
        }
    }

    setSelectedTab = async (idx) => {
        const validateDate = this.validateDateRange()
        if (validateDate.valid) {
            this.setState((prevState) => ({
                ...prevState,
                page: 1,
                searchPreferences: {
                    ...prevState.searchPreferences,
                    selectedTab: idx
                }
            }), async () => {
                this.setState({ loading: true })
                //localStorage.setItem("generalSearchPreferences", JSON.stringify(this.state.searchPreferences))

                switch (idx) {
                    case 0:
                        await this.getCalleds()
                        break
                    case 1:
                        await this.getNews()
                        break
                    case 2:
                        await this.getFaqs()
                        break
                    case 3:
                        await this.getKnowledgebases()
                        break
                    case 4:
                        await this.getUsers()
                        break
                    default:
                        break
                }

                this.setState({ loading: false })
            })
        } else {
            this.setNotification("error", validateDate.message)
        }
    }

    handleTabChange = (event, newValue) => {
        this.setState({ activeTab: newValue })
    }

    handleSwitchChange = (section, switchName, value) => {
        if (switchName === "startdate" || switchName === "enddate") {
            value = moment(value).format('YYYY/MM/DD HH:mm:ss')
        }
        this.setState((prevState) => ({
            searchPreferences: {
                ...prevState.searchPreferences,
                [section]: {
                    ...prevState.searchPreferences[section],
                    [switchName]: value
                }
            }
        }), () => {
            localStorage.setItem("generalSearchPreferences", JSON.stringify(this.state.searchPreferences))
            if (switchName === "startdate" || switchName === "enddate") {
                this.validateDateRange()
            }
        })
    }

    handleChangeSearchText = e => {
        const value = e.target.value
        this.setState((prevState) => ({
            ...prevState,
            searchPreferences: {
                ...prevState.searchPreferences,
                searchText: value
            }
        }))
    }

    closeNotification = () => {
        this.setState({ openNotification: false });
    }

    handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            this.handleSearch(this.state.activeTab)
        }
    }

    handleSearch = async () => {

        if (this.state.searchPreferences.searchText <= 0) {
            this.setNotification("error", this.props.intl.formatMessage({ id: "value.to.search" }))
            this.setState({ loading: false })
            return
        }

        const validateDate = this.validateDateRange()
        if (validateDate.valid) {
            this.setState({ loading: true })
            localStorage.setItem("generalSearchPreferences", JSON.stringify(this.state.searchPreferences))
            await this.getCalleds()
            await this.getUsers()
            await this.getNews()
            await this.getFaqs()
            await this.getKnowledgebases()
            this.setState({ loading: false })
        } else {
            this.setNotification("error", validateDate.message)
        }
    }

    setPagination(count, page) {
        let totalPage = Math.ceil(count / 10);
        this.setState({ totalPages: totalPage })
        if (count > 0) {
            if (page == 1) {
                if (count < 10) {
                    this.setState({ pageStart: 1, pageEnd: count });
                } else {
                    this.setState({ pageStart: 1, pageEnd: 10 });
                }
            } else {
                let pageStart = ((page - 1) * 10) + 1;
                if (count >= page * 10) {
                    this.setState({ pageStart: pageStart, pageEnd: page * 10 });
                } else {
                    this.setState({ pageStart: pageStart, pageEnd: count });
                }
            }
        } else {
            this.setState({ totalPages: 0, page: 1, count: 0, pageStart: 0, pageEnd: 0 });
        }
    }

    onChangePaginate = async (e, page) => {
        const validateDate = this.validateDateRange()
        if (validateDate.valid) {
            this.setState({ page: page }, async () => {
                this.setState({ loading: true })
                localStorage.setItem("generalSearchPreferences", JSON.stringify(this.state.searchPreferences))
                const tab = this.state.searchPreferences.selectedTab

                switch (tab) {
                    case 0:
                        await this.getCalleds()
                        break
                    case 1:
                        await this.getNews()
                        break
                    case 2:
                        await this.getFaqs()
                        break
                    case 3:
                        await this.getKnowledgebases()
                        break
                    case 4:
                        await this.getUsers()
                        break
                    default:
                        break
                }

                this.setState({ loading: false })
            })
        } else {
            this.setNotification("error", validateDate.message)
        }
    }

    setNotification = (variant, message) => {
        this.setState({
            openNotification: true,
            notificationVariant: variant,
            notificationMessage: message
        })
    }

    setLoading = (loading) => {
        this.setState({ loading: loading })
    }

    render() {
        const { classes, headerMenu, actionsHeaderMenu, match, history, intl } = this.props;
        const { calledsCount, usersCount, newsCount, faqsCount, knowledgebasesCount, searchResults, searchResultsCount, searchPreferences, settingsTabs, settingsOpen, activeTab, alertMessage, alertType } = this.state;

        if (Api == null) {
            var l = match.params.lang;
            document.location.href = `/${l}/unavailable`
        }

        return (
            <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
                <HeaderMenu />
                <main
                    className={clsx(classes.content, {
                        [classes.contentShift]: headerMenu.open,
                    }, classes.actionsContent, {
                        [classes.actionscontentShift]: actionsHeaderMenu.open,
                    })}
                >
                    <div className={classes.drawerHeader} />

                    <Container component='main' maxWidth='xl' style={{ paddingLeft: 0, marginLeft: 0 }}>
                        <div>
                            <CssBaseline />
                            <Grid container spacing={2} justifyContent='center' alignItems='center'>
                                <Grid container item xs={12} sm={10} md={10} lg={10} xl={10} spacing={2}>
                                    <Grid item xs={11} sm={11} >
                                        <TextField
                                            id='searchText'
                                            name='searchText'
                                            label={intl.formatMessage({ id: 'search' })}
                                            variant='outlined'
                                            fullWidth
                                            value={searchPreferences.searchText}
                                            onChange={this.handleChangeSearchText}
                                            onKeyDown={this.handleKeyDown}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <IconButton onClick={_ => this.handleSearch(activeTab)} >
                                                            <Search />
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={1} sm={1}>
                                        <ClickAwayListener onClickAway={this.handleClickAway}>
                                            <Box
                                                ref={this.containerRef}
                                                sx={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    maxWidth: 500,
                                                    width: "500px",
                                                    minWidth: "240px",
                                                    maxWidth: "100%",
                                                    transition: "all 0.1s ease",
                                                }}
                                            >
                                                <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    height="100%"
                                                    onClick={() => this.setState({ settingsOpen: !this.state.settingsOpen })}
                                                >
                                                    <IconButton >
                                                        <Settings />
                                                    </IconButton>
                                                </Button>
                                                {settingsOpen && <Paper
                                                    elevation={4}
                                                    sx={{
                                                        position: "absolute",
                                                        top: "calc(100% + 1px)",
                                                        right: 0,
                                                        zIndex: 1300,
                                                        borderTop: "1px solid",
                                                        borderColor: "primary.main",
                                                        borderRadius: "0 0 8px 8px",
                                                        width: "500px",
                                                        p: 2,
                                                        backgroundColor: "background.paper"
                                                    }}
                                                >
                                                    <Box display="flex" flexDirection="column" gap={2} >
                                                        <Tabs
                                                            value={activeTab}
                                                            onChange={this.handleTabChange}
                                                            variant="scrollable"
                                                            scrollButtons="auto"
                                                            sx={{ borderBottom: 1, borderColor: 'divider' }}
                                                        >
                                                            {settingsTabs.map((tab, index) => (
                                                                <Tab key={index} label={tab.label} />
                                                            ))}
                                                        </Tabs>
                                                        <Box mt={1} overflow="auto" maxHeight="250px" >
                                                            {
                                                                activeTab == 0 ?
                                                                    <Grid item container xs={12} sm={12} md={12} spacing={1}>
                                                                        <Grid item xs={11} sm={11} md={11} marginLeft={2} marginTop={1}>
                                                                            <FormControlLabel
                                                                                control={
                                                                                    <SimpleDatePicker
                                                                                        label={intl.formatMessage({ id: "start.date" })}
                                                                                        name='startDate'
                                                                                        stateName='startDate'
                                                                                        changeDate={(statename, value) => this.handleSwitchChange('general', 'startdate', value)}
                                                                                        currentDate={searchPreferences.general.startdate}
                                                                                        required
                                                                                    />
                                                                                }
                                                                            />
                                                                        </Grid>
                                                                        <Grid item xs={11} sm={11} md={11} marginLeft={2} >
                                                                            <FormControlLabel
                                                                                control={
                                                                                    <SimpleDatePicker
                                                                                        label={intl.formatMessage({ id: "end.date" })}
                                                                                        name='endDate'
                                                                                        stateName='endDate'
                                                                                        changeDate={(statename, value) => this.handleSwitchChange('general', 'enddate', value)}
                                                                                        currentDate={searchPreferences.general.enddate}
                                                                                        required
                                                                                    />
                                                                                }
                                                                            />
                                                                        </Grid>
                                                                        <Grid item xs={12} sm={12} md={12} >
                                                                            <Alert severity={alertType} variant="standard">
                                                                                {alertMessage}
                                                                            </Alert>
                                                                        </Grid>
                                                                    </Grid>
                                                                    :
                                                                    settingsTabs[activeTab].switches.map((s, idx) => {
                                                                        switch (s.name) {
                                                                            case "quicksearch":
                                                                                return (
                                                                                    <Grid item container xs={12} sm={12} md={12} key={idx}>
                                                                                        <Grid item xs={11} sm={11} md={11} >
                                                                                            <FormControlLabel
                                                                                                control={
                                                                                                    <Switch
                                                                                                        defaultChecked={s.label !== "Ticket properties"}
                                                                                                        checked={searchPreferences[settingsTabs[activeTab].name][s.name]}
                                                                                                        onChange={(event, value) => this.handleSwitchChange(settingsTabs[activeTab].name, s.name, value)}
                                                                                                    />
                                                                                                }
                                                                                                label={s.label}
                                                                                                disabled={!this.usematerializedview}
                                                                                            />
                                                                                        </Grid>
                                                                                        <Grid item xs={1} sm={1} md={1} >
                                                                                            <Tooltip title={intl.formatMessage({ id: "quick.search.tooltip" })}>
                                                                                                <Info />
                                                                                            </Tooltip>
                                                                                        </Grid>
                                                                                        {
                                                                                            !searchPreferences.calleds.quicksearch && this.usematerializedview && 
                                                                                            <Grid item xs={12} sm={12} md={12} >
                                                                                                <Alert severity="warning" variant="standard">
                                                                                                    {intl.formatMessage({ id: "quick.search.info" })}
                                                                                                </Alert>
                                                                                            </Grid>
                                                                                        }
                                                                                    </Grid>
                                                                                )
                                                                            case "description":
                                                                                return (
                                                                                    <Grid item container xs={12} sm={12} md={12} key={idx}>
                                                                                        <Grid item xs={11} sm={11} md={11} >
                                                                                            <FormControlLabel
                                                                                                key={idx}
                                                                                                control={
                                                                                                    <Switch
                                                                                                        defaultChecked={s.label !== "Ticket properties"}
                                                                                                        checked={searchPreferences[settingsTabs[activeTab].name][s.name]}
                                                                                                        onChange={(event, value) => this.handleSwitchChange(settingsTabs[activeTab].name, s.name, value)}
                                                                                                    />
                                                                                                }
                                                                                                label={s.label}
                                                                                            />
                                                                                        </Grid>
                                                                                        <Grid item xs={1} sm={1} md={1} key={idx}>
                                                                                            <Tooltip title={intl.formatMessage({ id: "general.search.description.tooltip" })}>
                                                                                                <Info />
                                                                                            </Tooltip>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                )
                                                                            default:
                                                                                return (
                                                                                    <Grid item xs={12} sm={6} md={4} key={idx}>
                                                                                        <FormControlLabel
                                                                                            key={idx}
                                                                                            control={
                                                                                                <Switch
                                                                                                    defaultChecked={s.label !== "Ticket properties"}
                                                                                                    checked={searchPreferences[settingsTabs[activeTab].name][s.name]}
                                                                                                    onChange={(event, value) => this.handleSwitchChange(settingsTabs[activeTab].name, s.name, value)}
                                                                                                />
                                                                                            }
                                                                                            label={s.label}
                                                                                        />
                                                                                    </Grid>
                                                                                )
                                                                        }
                                                                    })
                                                            }
                                                            {settingsTabs[activeTab].switches.length === 0 && (
                                                                <Typography variant="body2" color="text.secondary">
                                                                    No preferences available for this section.
                                                                </Typography>
                                                            )}
                                                        </Box>
                                                    </Box>
                                                </Paper>}
                                            </Box>
                                        </ClickAwayListener>
                                    </Grid>
                                    <Grid item xs={12} sm={12} style={{ marginTop: 20 }}>
                                        <RTabs selectedIndex={searchPreferences.selectedTab} onSelect={index => this.setSelectedTab(index)} >
                                            <RTabList style={{ borderColor: '#BB8FCE' }}>
                                                <RTab>{intl.formatMessage({ id: "called.header" })} {'('}{calledsCount}{')'}</RTab>
                                                <RTab>{intl.formatMessage({ id: "news" })} {'('}{newsCount}{')'}</RTab>
                                                <RTab>{intl.formatMessage({ id: "faq" })} {'('}{faqsCount}{')'}</RTab>
                                                <RTab>{intl.formatMessage({ id: "knowledgebases" })} {'('}{knowledgebasesCount}{')'}</RTab>
                                                {this.isAdm && <RTab>{intl.formatMessage({ id: "menu.users" })} {'('}{usersCount}{')'}</RTab>}
                                            </RTabList>
                                            <RTabPanel>
                                                <Grid container spacing={2} style={{ marginTop: 8 }}>
                                                    {!this.state.loading && searchResults && searchResults.map((called, index) => (
                                                        <CalledCard
                                                            called={called}
                                                            isAdm={this.isAdm}
                                                            isClient={this.isClient}
                                                            intl={intl}
                                                            history={history}
                                                            lang={match.params.lang}
                                                            setNotification={this.setNotification}
                                                            setLoading={this.setLoading}
                                                        />
                                                    ))}
                                                </Grid>
                                            </RTabPanel>
                                            <RTabPanel>
                                                <Grid container spacing={2} style={{ marginTop: 8 }}>
                                                    {!this.state.loading && searchResults && searchResults.map((article, index) => (
                                                        <ArticleCard
                                                            article={article}
                                                            intl={intl}
                                                            history={history}
                                                            lang={match.params.lang}
                                                            setNotification={this.setNotification}
                                                            setLoading={this.setLoading}
                                                        />
                                                    ))}
                                                </Grid>
                                            </RTabPanel>
                                            <RTabPanel>
                                                <Grid container spacing={2} style={{ marginTop: 8 }}>
                                                    {!this.state.loading && searchResults && searchResults.map((faq, index) => (
                                                        <FaqCard
                                                            faq={faq}
                                                            intl={intl}
                                                            history={history}
                                                            lang={match.params.lang}
                                                            setNotification={this.setNotification}
                                                            setLoading={this.setLoading}
                                                        />
                                                    ))}
                                                </Grid>
                                            </RTabPanel>
                                            <RTabPanel>
                                                <Grid container spacing={2} style={{ marginTop: 8 }}>
                                                    {!this.state.loading && searchResults && searchResults.map((knowledgebase, index) => (
                                                        <KnowledgeBaseCard
                                                            knowledgebase={knowledgebase}
                                                            intl={intl}
                                                            history={history}
                                                            lang={match.params.lang}
                                                            setNotification={this.setNotification}
                                                            setLoading={this.setLoading}
                                                        />
                                                    ))}
                                                </Grid>
                                            </RTabPanel>
                                            {this.isAdm && <RTabPanel>
                                                <Grid container spacing={2} style={{ marginTop: 8 }}>
                                                    {!this.state.loading && searchResults && searchResults.map((user, index) => (
                                                        <UserCard
                                                            user={user}
                                                            intl={intl}
                                                            history={history}
                                                            lang={match.params.lang}
                                                            setNotification={this.setNotification}
                                                            setLoading={this.setLoading}
                                                        />
                                                    ))}
                                                </Grid>
                                            </RTabPanel>}
                                        </RTabs>
                                        <Grid container style={{ marginBottom: 12, marginTop: 8 }} spacing={1}>
                                            <Grid item xs={12} md={5}>
                                                <Pagination count={this.state.totalPages} page={this.state.page} onChange={this.onChangePaginate} />
                                            </Grid>
                                            {!this.state.loading && <Grid item xs={12} sm={3} style={{ marginTop: 6 }}>
                                                {this.state.pageStart} {<FormattedMessage id="to" />} {this.state.pageEnd} {<FormattedMessage id="of" />} {searchResultsCount} {<FormattedMessage id="register" />}
                                            </Grid>}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </div>
                    </Container>

                    {this.state.loading && (
                        <Overlay>
                            <CircularProgress color='secondary' />
                        </Overlay>
                    )}

                    <CustomizedSnackbars
                        variant={this.state.notificationVariant}
                        message={this.state.notificationMessage}
                        isOpen={this.state.openNotification}
                        toClose={this.closeNotification}
                    />
                </main>
            </div>
        )
    }
}

GeneralSearch.propTypes = {
    classes: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
    actionsHeaderMenu: state.actionsHeaderMenu,
    headerMenu: state.headerMenu,
    userSession: state.userSession,
});
const mapDispatchToProps = dispatch =>
    bindActionCreators(componentActions, dispatch);
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(GeneralSearch)));

GeneralSearch.contextType = AbilityContext; 